/* eslint-disable prefer-const */
import { API_CONFIG, getApiUrl } from "@/config/apiConfig";
import { getAuthHeaders } from "./authApi";
import { handleResponse, handleListResponse } from "./apiHandler";

export interface Transaction {
  _id: string;
  user_id: {
    _id: string;
    f_name: string;
    l_name: string;
  };
  subscription_id: {
    _id: string;
    plan_id: {
      _id: string;
      name: string;
      pricing: number;
      duration: string;
    };
    start_date: string;
    end_date: string;
    status: number;
  };
  payment_id: string;
  payment_status: number;
  sub_total: string;
  discount_price: string;
  total: string;
  offer_id: string | null;
  date: string;
  time: string;
  created_at: string;
}

export interface TransactionsResponse {
  message: string;
  value: Transaction[];
  pagination: {
    total: number;
    page: number;
    pageSize: number;
    totalPages: number;
  };
}

export const getBillings = async (
  userId: string,
  page = 1,
  pageSize = 10,
  search: string = "",
  status?: number,
  startDate?: string,
  endDate?: string
) => {
  try {
    let endpoint = API_CONFIG.endpoints.transactions.list.replace(
      ":user_id",
      userId
    );
    let url = `${getApiUrl(endpoint)}?page=${page}&pageSize=${pageSize}`;

    if (search) url += `&search=${search}`;
    if (status !== undefined && status !== null)
      url += `&payment_status=${status}`;
    if (startDate) url += `&start_date=${startDate}`;
    if (endDate) url += `&end_date=${endDate}`;

    const response = await fetch(url, {
      method: "GET",
      headers: getAuthHeaders(),
    });

    return await handleListResponse(response, "Fetch Billings", { page, pageSize });
  } catch (error) {
    console.error("Error fetching transactions:", error);

    return {
      value: [],
      pagination: {
        page: 1,
        pageSize,
        total: 0,
        totalPages: 0,
      },
      status: 500,
      message: "Server error. Please try again later.",
    };
  }
};

export const getBillingsDetails = async (billingId: string) => {
  const endpoint = API_CONFIG.endpoints.transactions.details.replace(
    ":billing_id",
    billingId
  );
  const url = getApiUrl(endpoint);

  const response = await fetch(url, {
    method: "GET",
    headers: getAuthHeaders(),
  });

  const result = await handleResponse(response, "Fetch Billing Details");
  return result.value;
};
